
import { Component, Prop, Vue } from 'vue-property-decorator';
import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { schedule6DataInfoType } from '@/types/Application/ReplyFamilyLawMatter/Pdf';
import { replyExistingContactWithChildDataInfoType } from '@/types/Application/ReplyFamilyLawMatter/ContactWithChild';

@Component({
    components:{
        UnderlineForm,
        CheckBox
    }
})

export default class Schedule6 extends Vue {

    @Prop({required:true})
    result!: any; 
   
    dataReady = false;
    exChContInfo = {} as schedule6DataInfoType;
   
    mounted(){
        this.dataReady = false;      
        this.extractInfo();       
        this.dataReady = true;        
    }    

    public extractInfo(){ 
        this.exChContInfo = this.getExistingChildContactInfo(); 
    }

    public getExistingChildContactInfo(){

        let existingChildContactInfo = {} as schedule6DataInfoType;

        existingChildContactInfo = {
            agreeCircumstanceChanges: false,
            disAgreeCircumstanceChanges: false,
            agreeChanges: false,
            agreeBestInterest: false,
            disagreeReason: '',
            continue: false,
            change: false,
            changeDetails: '',    
            bstIntrst: ''
        } 

        if (this.result.replyExistingContactWithChildSurvey){
            const existingContactInfo: replyExistingContactWithChildDataInfoType = this.result.replyExistingContactWithChildSurvey;
            // console.log(existingContactInfo)

            if (existingContactInfo.existingType == 'finalOrder'){

                existingChildContactInfo.agreeCircumstanceChanges = existingContactInfo.agreeFinalOrder == 'y';
                existingChildContactInfo.disAgreeCircumstanceChanges = existingContactInfo.agreeFinalOrder == 'n';
                existingChildContactInfo.agreeChanges = false;
                existingChildContactInfo.agreeBestInterest = false;
            } else if (existingContactInfo.existingType == 'agreement'){
                existingChildContactInfo.agreeChanges = existingContactInfo.agreeAgreement == 'y';
                existingChildContactInfo.agreeBestInterest = existingContactInfo.agreeAgreement == 'n';
                existingChildContactInfo.agreeCircumstanceChanges = false;
                existingChildContactInfo.disAgreeCircumstanceChanges = false;
            }
            
            existingChildContactInfo.disagreeReason = existingContactInfo.disagreeReason;

            existingChildContactInfo.continue = existingContactInfo.requestedOrder == 'noChange';
            existingChildContactInfo.change = existingContactInfo.requestedOrder == 'diffChange';
            existingChildContactInfo.changeDetails = existingContactInfo.requestedOrder == 'diffChange'?existingContactInfo.requestedChangeDescription:'';    
            existingChildContactInfo.bstIntrst = existingContactInfo.childBestInterestReason?existingContactInfo.childBestInterestReason: '';
        }        

        return existingChildContactInfo;
    }  

}
